import React from "react";
import { ToolbarSection, ToolbarItem } from "../../../editor";

export const YoutubeSettings = () => {
  return (
    <>
      <ToolbarSection title="Options">
        <ToolbarItem
          full={true}
          propKey="videoId"
          label="Vide ID:"
          type="text"
        />
        <ToolbarItem full={true} propKey="width" label="Width:" type="text" />
        <ToolbarItem full={true} propKey="height" label="Height:" type="text" />
      </ToolbarSection>
    </>
  );
};
